import { WireTypes } from '@flakiness/server/common/wireTypes.js';
import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { forgeUtils } from '../forgeUtils.js';
import { linkStyles } from './cssstyles.js';

@customElement('teststats-title')
class TestStatsTitle extends LitElement {
  @consume({ context: contexts.project, subscribe: true }) private _project?: ContextType<typeof contexts.project>;

  @property({ attribute: false }) testStats?: WireTypes.TestStats;

  render() {
    const stats = this.testStats;
    if (!stats)
      return nothing;
    const elements: TemplateResult[] = [];
    for (const title of stats.test.titles.slice(0, -1).filter(t => !!t)) {
      elements.push(html`<span>${title}</span>`);
      elements.push(html`<sl-icon name=chevron-right></sl-icon>`)
    }
    elements.pop();

    const testTitle = stats.test.titles.at(-1);

    return html`
      <v-box style="gap: var(--sl-spacing-2x-small);">
        <span class=suite-titles>${elements}</span>
        <span class=test-title>${testTitle} <slot name=suffix></slot></span>
        ${stats.test.filePath ? html`
          <h-box style="gap: var(--sl-spacing-2x-small)">
            <a-ext href=${forgeUtils.hasSourceUrl(this._project) ? forgeUtils.testUrl(this._project, stats) ?? nothing : nothing} class=test-link>${stats.test.filePath}:${stats.lineNumber}</a-ext>
            <sl-copy-button value=${`${stats.test.filePath}:${stats.lineNumber}`}></sl-copy-button>
          </h-box>
        ` : nothing}
        ${stats.tags?.length ? html`
          <h-box>${stats.tags.map(tag => html`<span class=test-tag>#${tag}</span>`)}
          </h-box>
        ` : nothing}
      </v-box>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: block;
    }

    sl-copy-button {
      visibility: hidden;
    }

    .test-tag {
      color: var(--sl-color-neutral-600);
      font-size: var(--sl-font-size-small);
      background-color: var(--sl-color-neutral-100);
      padding: var(--sl-spacing-2x-small);
      border-radius: var(--sl-border-radius-medium);
    }

    *:hover > sl-copy-button {
      visibility: visible;
    }

    .suite-titles {
      font-size: var(--sl-font-size-small);
      color: var(--sl-color-neutral-500);
    }

    .test-title {
      font-size: var(--sl-font-size-2x-large);
    }

    .test-link {
      font-size: var(--sl-font-size-small);
      color: var(--sl-color-neutral-500);
    }

    sl-icon {
      font-size: 73%;
    }
  `];
}